const config = {
  subscriptionsEndpoint: "/api/commerce/subscriptionsoptions/v1/subscriptions",
};

export default config;
